import './FieldUpdateMetadataTab.scss';
import { CodeHighlight } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PeriscopeFieldRow } from '@periscopes/general/fields';
import { SalesforceDescription } from '@ui/text';
import { DetailSection, DetailSubsection, InformationSection } from '@periscopes/general';
import { MetadataContainer } from '@periscopes/general/metadata';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useEffect, useMemo } from 'react';
import { useAction, useApiResource, usePeriscopeMetadata } from '@hooks';
export const FieldUpdateMetadataTab = ({ index, sonarObjectId }) => {
    var _a, _b;
    const updateReferences = useAction(coreActions.updateSonarObjectReferences);
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.SalesforceFieldUpdate);
    const { loading: loadingRefs, resource: refsResource } = useApiResource(`v3/salesforce/field-updates/${sonarObjectId}/references`);
    const metadataEntries = useMemo(() => {
        if (!metadata) {
            return [];
        }
        const entries = [
            {
                label: COPY_SPECIFIC.OBJECT,
                type: 'string',
                value: metadata.object
            },
            {
                label: COPY_SPECIFIC.RE_EVALUATE_AFTER_FIELD_CHANGE,
                type: 'boolean',
                value: metadata.shouldReevaluateOnChange
            }
        ];
        return entries;
    }, [metadata]);
    useEffect(() => {
        if (refsResource === null || refsResource === void 0 ? void 0 : refsResource.field) {
            updateReferences([
                {
                    displayName: refsResource.field.displayName,
                    ingestedBy: refsResource.field.ingestedBy,
                    parentDisplayName: refsResource.field.parentDisplayName,
                    parentSonarObjectId: refsResource.field.parentSonarObjectId,
                    populatedBy: refsResource.field.populatedBy,
                    relatedCounts: refsResource.field.relatedCounts,
                    sonarObjectId: refsResource.field.sonarObjectId,
                    sonarObjectType: SonarObjectType.SalesforceField,
                    tags: refsResource.field.tagIds
                }
            ]);
        }
    }, [refsResource === null || refsResource === void 0 ? void 0 : refsResource.field, updateReferences]);
    if (loading || loadingRefs) {
        return React.createElement(LoadingSpinner, { spinning: true });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(InformationSection, { sonarObjectId: sonarObjectId },
            React.createElement(SalesforceDescription, { sonarObjectId: sonarObjectId })),
        React.createElement(DetailSection, { className: 'field-update-details', spacing: 'small' },
            React.createElement(MetadataContainer, { entries: metadataEntries, title: COPY_SPECIFIC.WORKFLOW_DETAIL }),
            React.createElement(DetailSubsection, { spacing: 'none', title: COPY_SPECIFIC.FIELD_TO_UPDATE },
                React.createElement(PeriscopeFieldRow, { field: refsResource === null || refsResource === void 0 ? void 0 : refsResource.field, parentIndex: index, useApiNames: false })),
            React.createElement(DetailSubsection, { spacing: 'none', title: (refsResource === null || refsResource === void 0 ? void 0 : refsResource.isFormula) ? COPY_SPECIFIC.FORMULA : COPY_SPECIFIC.VALUE },
                React.createElement(CodeHighlight, { code: (_a = refsResource === null || refsResource === void 0 ? void 0 : refsResource.value) !== null && _a !== void 0 ? _a : '', codeReferences: (_b = refsResource === null || refsResource === void 0 ? void 0 : refsResource.codeReferences) !== null && _b !== void 0 ? _b : [], index: index })))));
};
